import PaginationDataResourceModel from '../../generated/types/model/resource/PaginationDataResourceModel';

export default class PaginationDataResourceViewModel extends PaginationDataResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
